// extracted by mini-css-extract-plugin
export default {"productImageBox":"ProductImage_productImageBox__bd0Vh","image":"ProductImage_image__vVvwr"};